"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ErrorExplorer;
(function (ErrorExplorer) {
    ErrorExplorer["get_object_error"] = "get_object_error";
    ErrorExplorer["wrong_id_error"] = "wrong_id_error";
})(ErrorExplorer = exports.ErrorExplorer || (exports.ErrorExplorer = {}));
var Space;
(function (Space) {
    Space[Space["relative_protocol_ids"] = 0] = "relative_protocol_ids";
    Space[Space["protocol_ids"] = 1] = "protocol_ids";
    Space[Space["implementation_ids"] = 2] = "implementation_ids";
})(Space = exports.Space || (exports.Space = {}));
var Type;
(function (Type) {
    var Protocol;
    (function (Protocol) {
        Protocol[Protocol["null"] = 0] = "null";
        Protocol[Protocol["base"] = 1] = "base";
        Protocol[Protocol["account"] = 2] = "account";
        Protocol[Protocol["asset"] = 3] = "asset";
        Protocol[Protocol["miner"] = 4] = "miner";
        Protocol[Protocol["custom"] = 5] = "custom";
        Protocol[Protocol["proposal"] = 6] = "proposal";
        Protocol[Protocol["operation_history"] = 7] = "operation_history";
        Protocol[Protocol["withdraw_permission"] = 8] = "withdraw_permission";
        Protocol[Protocol["vesting_balance"] = 9] = "vesting_balance";
        Protocol[Protocol["OBJECT_TYPE_COUNT"] = 10] = "OBJECT_TYPE_COUNT"; // 10
    })(Protocol = Type.Protocol || (Type.Protocol = {}));
    var Implementation;
    (function (Implementation) {
        Implementation[Implementation["global_property"] = 0] = "global_property";
        Implementation[Implementation["dynamic_global_property"] = 1] = "dynamic_global_property";
        Implementation[Implementation["reserved"] = 2] = "reserved";
        Implementation[Implementation["asset_dynamic_data_type"] = 3] = "asset_dynamic_data_type";
        Implementation[Implementation["account_balance"] = 4] = "account_balance";
        Implementation[Implementation["account_statistics"] = 5] = "account_statistics";
        Implementation[Implementation["transaction"] = 6] = "transaction";
        Implementation[Implementation["block_summary"] = 7] = "block_summary";
        Implementation[Implementation["account_transaction_history"] = 8] = "account_transaction_history";
        Implementation[Implementation["chain_property"] = 9] = "chain_property";
        Implementation[Implementation["miner_schedule"] = 10] = "miner_schedule";
        Implementation[Implementation["budget_record"] = 11] = "budget_record";
        Implementation[Implementation["buying"] = 12] = "buying";
        Implementation[Implementation["content"] = 13] = "content";
        Implementation[Implementation["publisher"] = 14] = "publisher";
        Implementation[Implementation["subscription"] = 15] = "subscription";
        Implementation[Implementation["seeding_statistics"] = 16] = "seeding_statistics";
        Implementation[Implementation["transaction_detail"] = 17] = "transaction_detail";
        Implementation[Implementation["messaging"] = 18] = "messaging";
    })(Implementation = Type.Implementation || (Type.Implementation = {}));
})(Type = exports.Type || (exports.Type = {}));
//# sourceMappingURL=explorer.js.map


//////////////////
// WEBPACK FOOTER
// ./lib/model/explorer.js
// module id = 227
// module chunks = 0